import SettingsLayout from "../Layout";

import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';

// Tabs
import QuicbooksTab from "./Tabs/Quickbooks";


  const tabContent = [
    {panel: "quickbooks", content: <QuicbooksTab />},
  ]

const QuicbooksSettings = () => {

  const tabs = [
    {label: "Sync Account", icon: <ReceiptLongRoundedIcon fontSize="small" />},
  ];

  return (
    <SettingsLayout title="Quickbooks" identifier="setting_id" tabs={tabs} tabContent={tabContent} url="settings/accounting">

    </SettingsLayout>
  )
};

export default QuicbooksSettings;